import { InvoiceController } from '../../controllers';
import React, { useState } from 'react';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { Checkout } from '../../pages';
import { observer } from 'mobx-react';
import * as yup from 'yup';
import { phoneRegExp } from '../../utils/utils';

const CheckoutContainer = () => {
	const [activeImg, setActiveImage] = useState('Image1');
	const [payInfo, setPayInfo] = useState(false);
	const [pay, setPay] = useState(false);
	const [loading, setLoading] = useState(false);

	const showPayInfo = () => {
		setPayInfo(true);
	};

	const customerDetailsValidation = () => {
		return yup.object({
			fullname: yup.string().required('Your name is required'),
			mobile: yup.string().matches(phoneRegExp, 'Phone number is not valid').required('Your phone number is required'),
			email: yup.string().email().required('Your email is required'),
			country: yup.string().required('Your country is required'),
			state: yup.string().required('Your state is required'),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		for (const key in payload) {
			if (payload[key] === '') {
				delete payload[key];
			}
		}
		const { status, errorMessage } = await InvoiceController.createToshoInvoice(
			payload
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return setPay(true);
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const goBack = () => {
		if (pay && payInfo) {
			setPay(false);
		} else if (payInfo) {
			setPayInfo(false);
		}
	};
	return (
		<Checkout
			activeImg={activeImg}
			setActiveImage={setActiveImage}
			payInfo={payInfo}
			showPayInfo={showPayInfo}
			goBack={goBack}
			pay={pay}
			loading={loading}
			onSubmit={onSubmit}
			customerDetailsValidation={customerDetailsValidation}
		/>
	);
};

export default observer(CheckoutContainer);